import React from 'react';

const SystemBanner = ({ rootClassname, className, headerSection, show }) => {
  const { bannerUrl, title } = headerSection.componentData;
  if (!show) {
    return null
  }
  return (
    <div
      className={
        `flex w-full flex-col flex-1 px-8 lg:mx-auto max-w-7xl ${rootClassname}`
      }
    >
      <div
        className={`${className} relative w-full overflow-hidden rounded-[32px]`}
      >
        <img
          className="w-full h-auto object-cover  shadow-2xl"
          src={bannerUrl}
          alt={`${title} banner`}
        />
      </div>
    </div>
  );
};

export default SystemBanner;
